import { Controller, useFormContext } from 'react-hook-form';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';

const SitesField = () => {
  const { control } = useFormContext();

  return (
    <FormControlLabel
      label="DOES THIS DATASET HAVE SITES?"
      required
      sx={{ width: 'fit-content' }}
      control={
        <Controller
          name="have_sites"
          control={control}
          disabled
          render={({ field }) => (
            <RadioGroup row {...field} sx={{ gap: 6 }}>
              {[true, false].map((type) => (
                <FormControlLabel
                  key={type.toString()}
                  labelPlacement="end"
                  disabled
                  value={type}
                  control={<Radio size="small" />}
                  label={type ? 'Yes' : 'No'}
                />
              ))}
            </RadioGroup>
          )}
        />
      }
    />
  );
};

export default SitesField;
